/**
 login-view
 Created by RuSsCiTy on 07.05.2018
 **/

import Backbone from "backbone";
import { PAGES } from "../../../const/constants";
import { mainChannel, viewChannel } from "../../../init/message-hub";
import CookieContainer from "./partials/container/cookie-container";

const template = require("./template.pug");
require("./style.scss");

export default Backbone.View.extend({
  className: "detailsView",

  events: {
    "click .basic": "gotoBasic",
    "click .accept-cookie-btn": "acceptCookies"
  },

  initialize(container) {
    this.render(container);
    this.initContainers();
    this.initElements();
    this.initCookieContainers();
  },

  render() {
    this.$el.html(template);
  },

  initCookieContainers() {
    this.$mainContainer.html(this.containers.necessary.$el);
    this.$mainContainer.append(this.containers.preferences.$el);
    this.$mainContainer.append(this.containers.statistics.$el);
    this.$mainContainer.append(this.containers.marketing.$el);
  },

  initContainers() {
    const appliedConfig = mainChannel.request("appliedConfig");
    this.containers = {};
    this.containers.necessary = new CookieContainer(
      appliedConfig.necessary,
      true
    );
    this.containers.preferences = new CookieContainer(
      appliedConfig.preferences
    );
    this.containers.statistics = new CookieContainer(appliedConfig.statistics);
    this.containers.marketing = new CookieContainer(appliedConfig.marketing);
  },

  gotoBasic(e) {
    e.preventDefault();
    e.stopPropagation();
    viewChannel.request("showPage", PAGES.intro);
  },

  acceptCookies() {
    mainChannel.request("acceptCookies");
    viewChannel.request("togglePreferenceButton", true);
  },

  initElements() {
    this.$mainContainer = $(this.$(".modal-body"));
  },

  reset() {
    this.containers.necessary.reset();
    this.containers.preferences.reset();
    this.containers.statistics.reset();
    this.containers.marketing.reset();
  }
});



// WEBPACK FOOTER //
// ./src-cookie-manager/views/pages/details/details.js